// Initialize Swipers when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Check if thumbnail slider exists and has slides
    const thumbsContainer = document.querySelector('.mySwiper');
    const thumbsSlides = thumbsContainer ? thumbsContainer.querySelectorAll('.swiper-slide') : [];
    const hasMultipleSlides = thumbsSlides.length > 1;

    // Add CSS class for single slide styling
    if (thumbsContainer && !hasMultipleSlides) {
        thumbsContainer.classList.add('single-slide');
    }

    // Initialize thumbnail swiper only if it exists
    let swiper = null;
    if (thumbsContainer) {
        const swiperConfig = {
            spaceBetween: 12,
            slidesPerView: Math.min(3, thumbsSlides.length), // Don't show more slides than available
            breakpoints: {
                320: {    // Small screens
                    slidesPerView: Math.min(3, thumbsSlides.length),
                    spaceBetween: 7,
                },
                640: {    // Medium screens
                    slidesPerView: Math.min(3, thumbsSlides.length),
                    spaceBetween: 7,
                },
                768: {    // Larger tablets
                    slidesPerView: Math.min(3, thumbsSlides.length),
                    spaceBetween: 7,
                },
                1024: {   // Desktop screens
                    slidesPerView: Math.min(3, thumbsSlides.length),
                },
                1440: {   // Larger screens
                    slidesPerView: Math.min(3, thumbsSlides.length),
                },
            }
        };

        // Only add freeMode and watchSlidesProgress if there are multiple slides
        if (hasMultipleSlides) {
            swiperConfig.freeMode = true;
            swiperConfig.watchSlidesProgress = true;
        }

        try {
            swiper = new Swiper(".mySwiper", swiperConfig);
        } catch (error) {
            console.error('Error initializing thumbnail swiper:', error);
        }
    }

    // Initialize main image swiper
    let swiper2 = null;
    const mainContainer = document.querySelector('.mySwiper2');
    if (mainContainer) {
        const mainConfig = {
            spaceBetween: 10,
        };

        // Only set thumbs if swiper was successfully initialized and has multiple slides
        if (swiper && hasMultipleSlides) {
            mainConfig.thumbs = {
                swiper: swiper,
            };
        }

        try {
            swiper2 = new Swiper(".mySwiper2", mainConfig);
        } catch (error) {
            console.error('Error initializing main swiper:', error);
        }
    }

    // Add navigation event listeners only if swiper2 exists
    if (swiper2) {
        const back = document.querySelector('.back');
        const next = document.querySelector('.next');

        if (back) {
            back.addEventListener('click', () => {
                swiper2.slidePrev();
            });
        }

        if (next) {
            next.addEventListener('click', () => {
                swiper2.slideNext();
            });
        }
    }

    // Initialize zoom functionality for main swiper images
    initializeImageZoom();

    // Initialize product swiper (if it exists)
    const productContainer = document.querySelector('.mySwiperProduct');
    if (productContainer) {
        try {
            var swiper3 = new Swiper(".mySwiperProduct", {
                loop: false,
                spaceBetween: 20,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    320: {    // Small screens
                        slidesPerView: 1,
                    },
                    640: {    // Medium screens
                        slidesPerView: 2,
                    },
                    768: {    // Larger tablets
                        slidesPerView: 3,
                    },
                    1024: {   // Desktop screens
                        slidesPerView: 4,
                    },
                    1440: {   // Larger screens
                        slidesPerView: 5,
                    },
                    1920: {   // Full HD screens
                        slidesPerView: 6,
                    }
                }
            });
        } catch (error) {
            console.error('Error initializing product swiper:', error);
        }
    }
});

// Initialize image zoom functionality
function initializeImageZoom() {
    const mainSwiperSlides = document.querySelectorAll('.mySwiper2 .swiper-slide');

    mainSwiperSlides.forEach(slide => {
        const img = slide.querySelector('img:not([variationImage])');
        if (!img) return;

        // Set up the zoom URL CSS property
        const updateZoomUrl = () => {
            const imgSrc = img.getAttribute('src');
            if (imgSrc) {
                slide.style.setProperty('--zoom-url', `url(${imgSrc})`);
            }
        };

        // Initial setup
        updateZoomUrl();

        // Update zoom URL when image source changes (for variations)
        const observer = new MutationObserver(() => {
            updateZoomUrl();
        });
        observer.observe(img, { attributes: true, attributeFilter: ['src'] });

        slide.addEventListener('mousemove', (event) => {
            const rect = slide.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            // Calculate percentage position
            const xPercent = (x / rect.width) * 100;
            const yPercent = (y / rect.height) * 100;

            // Set CSS properties for zoom position
            slide.style.setProperty('--zoom-x', `${xPercent}%`);
            slide.style.setProperty('--zoom-y', `${yPercent}%`);
            slide.style.setProperty('--display', 'block');

            // Position the zoom circle at cursor
            slide.style.setProperty('--zoom-circle-x', `${x}px`);
            slide.style.setProperty('--zoom-circle-y', `${y}px`);
        });

        slide.addEventListener('mouseleave', () => {
            slide.style.setProperty('--display', 'none');
        });
    });
}

// Copy to clipboard functionality for product page
document.addEventListener('DOMContentLoaded', function() {
    // Find all copy link buttons (desktop and mobile) and add event listeners
    const copyButtons = document.querySelectorAll('[data-copy-link-product]');
    copyButtons.forEach(button => {
        button.addEventListener('click', function() {
            const urlToCopy = this.getAttribute('data-url');
            copyToClipboard(urlToCopy);
        });
    });
});

// Copy to clipboard functionality - make it globally accessible
window.copyToClipboard = function(text) {
    console.log('Copying to clipboard:', text); // Debug log

    if (navigator.clipboard && window.isSecureContext) {
        // Use the modern Clipboard API
        navigator.clipboard.writeText(text).then(function() {
            console.log('Successfully copied with Clipboard API');
            showCopyMessage('Link copiado!');
        }).catch(function(err) {
            console.error('Failed to copy text: ', err);
            fallbackCopyTextToClipboard(text);
        });
    } else {
        // Fallback for older browsers
        console.log('Using fallback copy method');
        fallbackCopyTextToClipboard(text);
    }
}

function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            showCopyMessage('Link copiado!');
        } else {
            showCopyMessage('Erro ao copiar link');
        }
    } catch (err) {
        console.error('Fallback: Could not copy text: ', err);
        showCopyMessage('Erro ao copiar link');
    }

    document.body.removeChild(textArea);
}

function showCopyMessage(message) {
    // Create a temporary message element
    const messageEl = document.createElement('div');
    messageEl.textContent = message.toUpperCase();
    messageEl.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        height: 65px;
        background: #D9BF80;
        color: #562E27;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        transition: all 0.3s ease;
        min-width: 203px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 700;
        line-height: 18.75px;
        letter-spacing: -0.02em;
        text-align: center;
        border-radius: 4px;
        z-index: 9999;
        box-shadow: 0 2px 10px rgba(86, 46, 39, 0.2);
        animation: slideInFromRight 0.3s ease-out;
    `;

    // Add CSS animation for slide-in effect
    if (!document.querySelector('#copyMessageAnimation')) {
        const style = document.createElement('style');
        style.id = 'copyMessageAnimation';
        style.textContent = `
            @keyframes slideInFromRight {
                from {
                    transform: translateX(100%);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            @keyframes slideOutToRight {
                from {
                    transform: translateX(0);
                    opacity: 1;
                }
                to {
                    transform: translateX(100%);
                    opacity: 0;
                }
            }
        `;
        document.head.appendChild(style);
    }

    document.body.appendChild(messageEl);

    // Remove the message after 3 seconds with slide-out animation
    setTimeout(() => {
        messageEl.style.animation = 'slideOutToRight 0.3s ease-out';
        setTimeout(() => {
            if (messageEl.parentNode) {
                document.body.removeChild(messageEl);
            }
        }, 300);
    }, 2500);
}
